import PropTypes from "prop-types";

const KitchenIcon = ({ width = 27, height = 25, color = "#31493C" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 27 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.5002 24H1V12.4675V10.4736H26.5002V24Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path d="M26.5002 13.1633H8.90033H1" stroke={color} strokeMiterlimit="10" />
    <path d="M8.30664 24V13.1633" stroke={color} strokeMiterlimit="10" />
    <path d="M15.0664 24V13.1633" stroke={color} strokeMiterlimit="10" />
    <path
      d="M23.6539 15.8712H17.9863V21.5388H23.6539V15.8712Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M23.8539 10.4528H17.7891V5.1825C17.7891 4.35949 18.4563 3.69226 19.2793 3.69226H22.361C23.184 3.69226 23.8513 4.35949 23.8513 5.1825V10.4528H23.8539Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path d="M23.8539 6.27551H17.7891" stroke={color} strokeMiterlimit="10" />
    <path d="M3.13477 1H14.0259" stroke={color} strokeMiterlimit="10" />
    <path d="M6.80469 1V3.1367" stroke={color} strokeMiterlimit="10" />
    <path
      d="M6.80547 5.17736C7.36898 5.17736 7.82579 4.72054 7.82579 4.15704C7.82579 3.59353 7.36898 3.13672 6.80547 3.13672C6.24197 3.13672 5.78516 3.59353 5.78516 4.15704C5.78516 4.72054 6.24197 5.17736 6.80547 5.17736Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path d="M10.4922 1V3.1367" stroke={color} strokeMiterlimit="10" />
    <path
      d="M10.493 5.17736C11.0565 5.17736 11.5133 4.72054 11.5133 4.15704C11.5133 3.59353 11.0565 3.13672 10.493 3.13672C9.92947 3.13672 9.47266 3.59353 9.47266 4.15704C9.47266 4.72054 9.92947 5.17736 10.493 5.17736Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path d="M5.78516 17.0005V19.1866" stroke={color} strokeMiterlimit="10" />
    <path d="M12.877 17.0005V19.1866" stroke={color} strokeMiterlimit="10" />
  </svg>
);

KitchenIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

export default KitchenIcon;
